import React, { FC, ReactNode, useReducer } from "react"
import { ContractorsReducer } from "./reducer"
import { ContractorsContextType } from "./types"

const initialState: ContractorsContextType = {
    // MODAL
    modalType: null,
    modalOpen: false,
}

export const ContractorsContext = React.createContext<{
    state: ContractorsContextType,
    dispatch: React.Dispatch<any>
}>({
    state: initialState,
    dispatch: () => null
})

export const ContractorsProvider: FC<{ children?: ReactNode }> = ({ children }) => {
    const [state, dispatch] = useReducer(ContractorsReducer, initialState)
    return (
        <ContractorsContext.Provider value={{ state, dispatch }}>
            {children}
        </ContractorsContext.Provider>
    )
}